




$(document).ready(function(){

  
    $('.program-image-slideshow').slick();
  
    $('.sticky-section').parent().addClass('sticky-section-container')
    $('.column-slider .inner').slick();
    $('.image-slider').slick();
  
  
  
    $('.our-impact .inner').slick({
      centerMode: true,
      centerPadding: '30%',
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: '80px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: true,
            centerPadding: '80px',
            slidesToShow: 1
          }
        }
      ]
    });

    $('.verification-login').click(function(e) {
      e.preventDefault();
      var codes = '';
      $(this).closest('.verification-code').find('.code').each(function() {
        codes += $(this).val()
      })
      
      var holder = $(this).closest('.verification-code').find('.holder').val();
      
      if(codes == holder) {
        $(this).closest('.verification-code').removeClass('error')
        $(this).closest('.verification-code').addClass('verified');
        window.location.href = $(this).closest('.verification-code').attr('url');

      }
      else {
        var here = $(this);
        $(this).closest('.verification-code').removeClass('error')
        setTimeout(function() {
          here.closest('.verification-code').addClass('error')
        }, 20)
      }
    })

    $('.verification-code .code').keyup(function(e) {
      if($.isNumeric(e.key)) {
        if($(this).val() != '') {
          $(this).val(e.key)
        }
      
        $(this).next().focus();
      }
    })

    $('.program-tabs .tab').click(function(e) {
      $(this).closest('.main-program-tabs').find('.active').removeClass('active');
      
    });


  
      
    var link = window.location.pathname.split('/');
    var index = link.length - 1;
    var tabActive = window.location.pathname.split('/')[index];
  
    $('.main-program-tabs').find('.tab[tab="' + tabActive + '"]').addClass('active')

  

  

    $('.program-tabs-mobile').change(function() {
      var tab = $(this).val();
      $(this).closest('.main-program-tabs').find('.active').removeClass('active');
      $(this).closest('.main-program-tabs').find('.programs[program="' + tab + '"]').addClass('active');
    })
  
});




if($('.template-suffix-at-home-activities video').length > 0) {
new Vlitejs('.template-suffix-at-home-activities video', {
    onReady: (player) => {
  
      $('.video-player-btn').click(function() {
          $(this).next('.popup-video').addClass('active');
      });
      $('.popup-video .close').click(function() {
          $(this).closest('.popup-video').removeClass('active')
        player.pause()
        
      });
      $(".popup-video").click(function(e){
         if(e.target == this){ // only if the target itself has been clicked
           player.pause()
           $(this).removeClass('active')
         }
      });

        
    }
  });
}
